import { ActionReducerMap } from "@ngrx/store";
// Reducers
import { configReducer } from "./reducers/config.reducer";
import { formReducer } from "./reducers/form.reducer";
import { versionReducer } from "./reducers/version.reducer";
import { valueReducer } from "./reducers/value.reducer";
import { templateReducer } from "./reducers/template.reducer";

// States
import { ConfigState } from "./states/config.state";
import { FormState } from "./states/form.state";
import { VersionState } from "./states/version.state";
import { ValueState } from "./states/value.state";
import { TemplateState } from "./states/template.state";

export interface AppState {
    config: ConfigState,
    form: FormState,
    version: VersionState,
    value: ValueState,
    template: TemplateState
}

export const ROOT_REDUCERS: ActionReducerMap<AppState> = {
    config: configReducer,
    form: formReducer,
    version: versionReducer,
    value: valueReducer,
    template: templateReducer
}